__turbopack_context__.v({
  "fixedPanel": "playgroundPanelControl-module-scss-module__NjXHQq__fixedPanel",
  "playground-buttons": "playgroundPanelControl-module-scss-module__NjXHQq__playground-buttons",
  "playgroundCheckbox": "playgroundPanelControl-module-scss-module__NjXHQq__playgroundCheckbox",
  "playgroundClose": "playgroundPanelControl-module-scss-module__NjXHQq__playgroundClose",
  "playgroundControls": "playgroundPanelControl-module-scss-module__NjXHQq__playgroundControls",
  "progressButtons": "playgroundPanelControl-module-scss-module__NjXHQq__progressButtons",
  "reset": "playgroundPanelControl-module-scss-module__NjXHQq__reset",
});
